import axios from "axios";
import { apiUrl } from "../../environment/environment";

const _axiosInstance = axios.create({
  baseURL: `${apiUrl}`, // Replace with your API base URL
  headers: {
    "Content-Type": "application/json",
    // Add your authorization token here
    "x-access-token": `${
      sessionStorage.getItem("accessToken") || sessionStorage.getItem("token")
    }`,
  },
});

export function getToken() {
  try {
    const token = JSON.parse(sessionStorage.getItem("accessToken"));
    return token;
  } catch (err) {
    // console.log("err", err);
    return null;
  }
}

export function attachToken(_token) {
  if (_token) {
    _axiosInstance.defaults.headers["x-access-token"] = _token;
  } else {
    console.error("Unauthorized. Token is required");
  }
}

export default _axiosInstance;

export const setupInterceptors = (setIsLoading) => {
  const ignoredEndpoints = ["/sendmessage"];
  let timeout;

  _axiosInstance.interceptors.request.use((config) => {
    if (!ignoredEndpoints.some((endpoint) => config.url.includes(endpoint))) {
      setIsLoading(true); // Show loading if the endpoint is not ignored
    }
    return config;
  });

  _axiosInstance.interceptors.response.use(
    (response) => {
      // Add a delay before hiding the spinner
      clearTimeout(timeout);
      timeout = setTimeout(() => setIsLoading(false), 500); // Delay for 500ms
      return response;
    },
    (error) => {
      // Add a delay before hiding the spinner on error
      clearTimeout(timeout);
      timeout = setTimeout(() => setIsLoading(false), 500); // Delay for 500ms
      console.error(error);
      return Promise.reject(error);
    }
  );
};
